import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
interface CountdownTimerProps {
  className?: string;
  theme?: 'dark' | 'light';
}
export function CountdownTimer({
  className = '',
  theme = 'dark'
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState({
    hours: 24,
    minutes: 0,
    seconds: 0
  });
  const [isExpired, setIsExpired] = useState(false);
  useEffect(() => {
    // Check local storage for existing end time
    const storedEndTime = localStorage.getItem('cenas_offer_end_time');
    let endTime: number;
    if (storedEndTime) {
      endTime = parseInt(storedEndTime, 10);
    } else {
      // Set end time to 24 hours from now
      endTime = new Date().getTime() + 24 * 60 * 60 * 1000;
      localStorage.setItem('cenas_offer_end_time', endTime.toString());
    }
    const updateTimer = () => {
      const now = new Date().getTime();
      const distance = endTime - now;
      if (distance < 0) {
        setIsExpired(true);
        setTimeLeft({
          hours: 0,
          minutes: 0,
          seconds: 0
        });
        return;
      }
      const hours = Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
      const minutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
      const seconds = Math.floor(distance % (1000 * 60) / 1000);
      setTimeLeft({
        hours,
        minutes,
        seconds
      });
    };
    updateTimer(); // Initial call
    const intervalId = setInterval(updateTimer, 1000);
    return () => clearInterval(intervalId);
  }, []);
  if (isExpired) {
    return <div className={`text-center font-bold text-xl py-4 px-6 rounded-lg border-2 border-urgency text-urgency bg-red-50 ${className}`} data-id="element-1">
        OFERTA EXPIRADA
      </div>;
  }
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  const bgClass = theme === 'dark' ? 'bg-dark text-white' : 'bg-urgency/10 text-urgency';
  const blockClass = theme === 'dark' ? 'bg-dark-light' : 'bg-white shadow-sm';
  const labelClass = theme === 'dark' ? 'text-gray-400' : 'text-urgency/70';
  return <div className={`flex flex-col items-center ${className}`} data-id="element-2">
      <div className="flex items-center gap-2 mb-3 text-sm font-semibold uppercase tracking-wider text-urgency" data-id="element-3">
        <Clock size={16} className="animate-pulse" data-id="element-4" />
        <span data-id="element-5">La oferta desaparece en:</span>
      </div>

      <div className={`flex items-center gap-2 md:gap-4 p-3 md:p-4 rounded-xl ${bgClass}`} data-id="element-6">
        <div className="flex flex-col items-center" data-id="element-7">
          <div className={`w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-lg text-2xl md:text-3xl font-bold font-serif ${blockClass}`} data-id="element-8">
            {formatNumber(timeLeft.hours)}
          </div>
          <span className={`text-[10px] md:text-xs mt-1 uppercase font-semibold ${labelClass}`} data-id="element-9">
            Horas
          </span>
        </div>

        <div className="text-2xl md:text-3xl font-bold pb-4" data-id="element-10">:</div>

        <div className="flex flex-col items-center" data-id="element-11">
          <div className={`w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-lg text-2xl md:text-3xl font-bold font-serif ${blockClass}`} data-id="element-12">
            {formatNumber(timeLeft.minutes)}
          </div>
          <span className={`text-[10px] md:text-xs mt-1 uppercase font-semibold ${labelClass}`} data-id="element-13">
            Minutos
          </span>
        </div>

        <div className="text-2xl md:text-3xl font-bold pb-4" data-id="element-14">:</div>

        <div className="flex flex-col items-center" data-id="element-15">
          <div className={`w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-lg text-2xl md:text-3xl font-bold font-serif ${blockClass}`} data-id="element-16">
            {formatNumber(timeLeft.seconds)}
          </div>
          <span className={`text-[10px] md:text-xs mt-1 uppercase font-semibold ${labelClass}`} data-id="element-17">
            Segundos
          </span>
        </div>
      </div>
    </div>;
}